import React from 'react';

import styles from './ArrowLeft.module.scss';


const ArrowLeft = (props) => {
  const classes = [styles.ArrowLeft, props.className];
  return (
    <div className={classes.join(' ')} onClick={props.onClick}>
      <div className={styles.ArrowUp}/>
      <div className={styles.ArrowDown}/>
    </div>
  );
};

export default ArrowLeft;
